module.exports = __webpack_public_path__ + "img/video3.bbbdd575.jpg";